export interface ITranslationsTableData {
    key?: string;
    name?: string;
    currentLocale: string | null;
    selectedLocale: string | null;
}
